import React, {useEffect, useState} from 'react';
import {IndividualsFormRead} from "../../components/individuals/IndividualsFormRead";
import {useGetIndividualQuery} from "../../store/backend-api/backend.api";
import {useSearchParams} from "react-router-dom";

export function ReadIndividualsForm () {
    const [searchParams] = useSearchParams()
    const id = Number(searchParams.get("id"))
    const {data, isSuccess} = useGetIndividualQuery(id)
    const [key, setKey] = useState(0)

    useEffect(() => {
        setKey((prevState) => prevState + 1)
    }, [data])

    return (<div key={key}>
        {isSuccess && <IndividualsFormRead data={data}/>}
    </div>)
}